export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f3c8b187205e6621aa1133c974722ed18719942a0&name=fetchTypeahead!'